import { useAccessibility } from "../../../context/AccessibilityContext/AccessibilityContext";
import Block from "../../../components/Block/Block";
import FadeIn from "../../../components/FadeIn/FadeIn";
import style from './servicesblock.module.scss';

const ServicesBlock = () => {
    const { settings } = useAccessibility();

    // Accessibility-aware colors
    const backgroundColor = settings.contrast === 'default' ? 'rgba(255, 255, 255, 0.85)' : 'var(--bg-primary)';
    const textColor = settings.contrast === 'default' ? '#231f20' : 'var(--text-primary)';

    return (
        <Block
            flexDirection='column'
            justifyContent='start'
            alignItems='start'
            width="75%"
            height='fit-content'
            background={backgroundColor}
            header='ПЛАТНЫЕ ОБРАЗОВАТЕЛЬНЫЕ УСЛУГИ'
            headerColor={textColor}
            id='services'
            aria-label="Платные образовательные услуги"
            role="region"
        >
            <FadeIn>
                <div className={style.content}>
                    <div className={style.wrapperData}>
                        {/* Информация об отсутствии платных услуг */}
                        <section aria-labelledby="no-paid-services">
                            <h4 id="no-paid-services" className={style.header} style={{ color: textColor }}>
                                Платные образовательные услуги
                            </h4>
                            <div className={style.text} style={{ color: textColor }}>
                                <p>
                                    ГБУ ДО КК «СШОР «Самбо» не оказывает платные образовательные услуги, в связи с этим отсутствуют следующие документы:
                                </p>
                                <ul className={style.list}>
                                    <li>о порядке оказания платных образовательных услуг, в том числе образец договора об оказании платных образовательных услуг</li>
                                    <li>об утверждении стоимости обучения по каждой образовательной программе</li>
                                    <li>об установлении размера платы, взимаемой с родителей (законных представителей) за присмотр и уход за детьми, осваивающими образовательные программы дошкольного образования в организациях, осуществляющих образовательную деятельность, за содержание детей в образовательной организации, реализующей образовательные программы начального общего, основного общего или среднего общего образования, если в такой образовательной организации созданы условия для проживания обучающихся в интернате, либо за осуществление присмотра и ухода за детьми в группах продленного дня в образовательной организации, реализующей образовательные программы начального общего, основного общего или среднего общего образования</li>
                                </ul>
                            </div>
                        </section>
                    </div>
                </div>
            </FadeIn>
        </Block>
    )
}

export default ServicesBlock;